import Box from '@mui/material/Box';

import useStyles from 'components/MenuMakeImport/Stepper/styles';

interface StepperStartTitleProps {
  children: React.ReactNode;
}

export function StepperStartTitle({ children }: StepperStartTitleProps) {
  const classes = useStyles();
  return <Box className={classes.stepperTitle}>{children}</Box>;
}
